import Vue from 'vue'
import {Util} from '../commons/util'

export default function () {
  Vue.filter('getStatus', function (val) {
    switch (val) {
      case '0':
        return '已抢购';
        break;
      case '1':
        return '已提货';
        break;
      case '2':
        return '已过期';
        break;
      default:
        return '';
    }
  });
  Vue.filter('businessType', function (businessCode) {
    
    let type;
    switch (businessCode) {
      case "0":
        type = "门店导购";
        break;
      case "1":
        type = "手机维修";
        break;
      case "2":
        type = "理财顾问";
        break;
      case "3":
        type = "育婴顾问";
        break;
    }
    return type;
  });
  // return example: 2017.01.10
  Vue.filter('formatDate', function (val) {
    
    const d = new Date(val);
    
    return Util.formatDate(d, '.');
  });
  
  Vue.filter('formatMonthDay', function (date) {
    
    let arr = date.split('-');
    
    return (arr[1] + '月' + arr[2] + '日');
    
  });
  Vue.filter('urlProtocol', function (imgUrl) {
  
    if (imgUrl) {
      return $.base.protocol(imgUrl);
    } else {
      return '';
    }
  });
}



// WEBPACK FOOTER //
// ./src/filter/index.js